export default __webpack_public_path__ + "static/media/landing.cf700c3a.jpeg";